module.exports = __webpack_public_path__ + "img/gra-account-check.65210a20.jpg";